<div class="step-three">
    <h2>¡Compra Confirmada!</h2>

    <img src="/assets/img/successful-purchase.webp" alt="Compra Exitosa" />

    <p>Tu pedido ha sido exitosamente confirmado, te enviaremos un mensaje de seguimiento al mail: <span>{{ userEmail || currentUser.email }}</span></p>

    <p>Tu número de compra es: <strong>{{ transactionId }}</strong></p>

    <div class="buttons">
        <button mat-button [routerLink]="['/']">Volver al inicio</button>
        <button mat-button [routerLink]="['/buscar-producto']">Seguir comprando</button>
    </div>
</div>
